<main class="mx-auto flex min-h-dvh max-w-3xl flex-col justify-center px-6 py-16">
  <p class="mb-3 text-center text-sm font-medium text-tomato">Acesso restrito</p>
  <app-ui-empty-state
    title="Permiss&atilde;o insuficiente"
    description="Seu usu&aacute;rio est&aacute; autenticado, mas n&atilde;o possui o papel ou permiss&atilde;o necess&aacute;ria para acessar esta &aacute;rea."
  >
    <a actions appButton routerLink="/" variant="primary">Voltar</a>
  </app-ui-empty-state>
</main>
